<template>
  <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
      <v-list three-line>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>Marketing Campaigns</v-list-tile-title>
            <v-list-tile-sub-title>Select which users you want to target for this campaign</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile>
          <v-btn @click="both_selected_users">Both</v-btn>
          <v-btn @click="email_selected_users">Email</v-btn>
          <v-btn @click="text_selected_users">Text</v-btn>
        </v-list-tile>
      </v-list>
      <v-card>
        <v-list subheader three-line v-for="(user, index) in users" :key="index">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title @click="show_user(user)">{{user.name}}</v-list-tile-title>
              <v-list-tile-sub-title>
                <v-switch v-model="user.canEmail" label="Email" color="indigo"></v-switch>
                <v-switch v-model="user.canText" label="Text" color="indigo"></v-switch>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider :key="index"></v-divider>
        </v-list>
      </v-card>
    </v-flex>
    <v-dialog v-model="dialog" width="500" v-if="dialog">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{ selected_user.name }}</v-card-title>

        <v-card-text>
          <span>
            Email:
            <br>
            {{this.selected_user.email }}
          </span>
          <br>
          <br>

          <span>
            Phone:
            <br>
            {{this.selected_user.phone }}
          </span>
          <br>
          <br>

          <span>
            Member since:
            <br>
            {{ this.selected_user.created }}
          </span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  mounted() {
    this.users = this.$store.getters.getUsers.map(el => {
      const obj = {
        name: el.name,
        email: el.email,
        phone: el.phone,
        created: Date(el.createdAt),
        canEmail: false,
        canText: false
      };
      return obj;
    });
  },
  data() {
    return {
      dialog: false,
      users: [],
      selected_user: null
    };
  },
  methods: {
    show_user(user) {
      this.dialog = !this.dialog;
      this.selected_user = user;
    },
    email_selected_users() {
      const users = this.users.filter(el => el.canEmail);
      console.log(users.map(u => u.email));
    },
    text_selected_users() {
      const users = this.users.filter(el => el.canText);
      console.log(users.map(u => u.phone));
    },
    both_selected_users() {
      const users = this.users.filter(el => el.canEmail && el.canText);
      console.log(
        users.map(u => {
          const obj = {
            email: u.email,
            phone: u.phone
          };
          return obj;
        })
      );
    }
  }
};
</script>

<style scoped>
</style>